export { default as Email } from 'notifications_historic/components/list/actions/NotificationsHistoricActionsEmail';
export { default as Edit } from 'notifications_historic/components/list/actions/NotificationsHistoricActionsEdit';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/list/actions/index.js